import * as React from "react";
import { IUserItem } from "@nkr/models/index";
import GroupUsersListItem from "./group-users-list-item";
import { Button, Glyphicon, InputGroup, FormControl } from "react-bootstrap";

interface IProps {
    items: IUserItem[],
    message: string,
    onSelect: (item: IUserItem) => void
    onSelectPrimary: (item: IUserItem) => void
}

interface IState {
    searchValue: string
}

class GroupUsersList extends React.Component<IProps, IState> {
    readonly state: IState = {
        searchValue: ""
    }

    handleSelect = (item: IUserItem) => {
        this.props.onSelect(item);
    }

    handleSelectPrimary = (item:IUserItem) => {
        this.props.onSelectPrimary(item);
    }

    handleSearchChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            searchValue: e.currentTarget.value
        });
    }

    handleClearSearch = () => {
        this.setState({
            searchValue: ""
        });
    }

    private filterItems = () => {
        if (this.state.searchValue.length >= 3) {
            return this.props.items.filter(item => {
                let name = item.user.lastName + ", " + item.user.firstName;

                return name.toUpperCase().indexOf(this.state.searchValue.toUpperCase()) >= 0;
            });
        } else {
            return this.props.items;
        }
    }

    render = () => {
        const filteredItems = this.filterItems();
        const nkrUsers = filteredItems.filter(x => x.user.centerId == 0);
        const centerUsers = filteredItems.filter(x => x.user.centerId > 0);

        return (
            <>
                <div style={{ display: "flex", marginBottom: 5 }}>
                    <InputGroup style={{ width: "100%" }}>
                        <FormControl
                            placeholder="To search, start typing..."
                            value={this.state.searchValue}
                            onChange={this.handleSearchChange}
                        />
                        <InputGroup.Button>
                            <Button onClick={this.handleClearSearch}><Glyphicon glyph="remove" /></Button>
                        </InputGroup.Button>
                    </InputGroup>
                </div>

                <div style={{ height: 150, width: "100%", overflowY: "scroll", border: "1px solid #bbb", padding: 5, borderRadius: 4 }}>
                    {centerUsers.length > 0 && (
                        <>
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                {centerUsers.map((item, index) =>
                                    <GroupUsersListItem
                                        key={index}
                                        item={item}
                                        backgroundColor="#CCC314"
                                        onSelect={this.handleSelect}
                                        onSelectPrimary={this.handleSelectPrimary}
                                    />
                                )}
                            </div>
                        </>
                    )}

                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {nkrUsers.map((item, index) =>
                            <GroupUsersListItem
                                key={index}
                                item={item}
                                backgroundColor="#87B7CF"
                                onSelect={this.handleSelect}
                                onSelectPrimary={this.handleSelectPrimary}
                            />
                        )}
                    </div>

                    {this.props.message && (
                        <>{this.props.message}</>
                    )}
                </div>
            </>
        );
    }
}

export default GroupUsersList;